import { render, staticRenderFns } from "./MicroneedlingSerumBadge.vue?vue&type=template&id=400a4514&scoped=true"
import script from "./MicroneedlingSerumBadge.vue?vue&type=script&lang=js"
export * from "./MicroneedlingSerumBadge.vue?vue&type=script&lang=js"
import style0 from "./MicroneedlingSerumBadge.vue?vue&type=style&index=0&id=400a4514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a4514",
  null
  
)

export default component.exports